/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by Warren Dowey
 */

export class MyPermissionsModel {
  private _userId?: string;
  private _roleId?: string;
  private _roleName?: string;
  private _roleDescription?: string;
  private _isEnabled?: boolean;
  private _componentId?: string;
  private _componentClass?: string;
  private _componentPath?: string;
  private _componentDescription?: string;
  private _componentName?: string;
  private _componentIsShared?: boolean;
  private _componentOwnerId?: string;
  private _sonraiOnly?: boolean;
  private _componentActionId?: string;
  private _componentActionDescription?: string;
  private _componentActionKey?: string;

  constructor(userId?: string,
              roleId?: string,
              roleName?: string,
              roleDescription?: string,
              isEnabled?: boolean,
              componentId?: string,
              componentClass?: string,
              componentPath?: string,
              componentDescription?: string,
              componentName?: string,
              componentIsShared?: boolean,
              componentOwnerId?: string,
              sonraiOnly?: boolean,
              componentActionId?: string,
              componentActionDescription?: string,
              componentActionKey?: string) {
    this.userId = userId;
    this.roleId = roleId;
    this.roleName = roleName;
    this.roleDescription = roleDescription;
    this.isEnabled = isEnabled;
    this.componentId = componentId;
    this.componentClass = componentClass;
    this.componentPath = componentPath;
    this.componentDescription = componentDescription;
    this.componentName = componentName;
    this.componentIsShared = componentIsShared;
    this.componentOwnerId = componentOwnerId;
    this.sonraiOnly = sonraiOnly;
    this.componentActionId = componentActionId;
    this.componentActionDescription = componentActionDescription;
    this.componentActionKey = componentActionKey;
  }
  get userId(): string {
    return this._userId;
  }

  set userId(value: string) {
    this._userId = value;
  }

  get roleId(): string {
    return this._roleId;
  }

  set roleId(value: string) {
    this._roleId = value;
  }

  get roleName(): string {
    return this._roleName;
  }

  set roleName(value: string) {
    this._roleName = value;
  }

  get roleDescription(): string {
    return this._roleDescription;
  }

  set roleDescription(value: string) {
    this._roleDescription = value;
  }

  get isEnabled(): boolean {
    return this._isEnabled;
  }

  set isEnabled(value: boolean) {
    this._isEnabled = value;
  }

  get componentId(): string {
    return this._componentId;
  }

  set componentId(value: string) {
    this._componentId = value;
  }

  get componentClass(): string {
    return this._componentClass;
  }

  set componentClass(value: string) {
    this._componentClass = value;
  }

  get componentPath(): string {
    return this._componentPath;
  }

  set componentPath(value: string) {
    this._componentPath = value;
  }

  get componentDescription(): string {
    return this._componentDescription;
  }

  set componentDescription(value: string) {
    this._componentDescription = value;
  }

  get componentName(): string {
    return this._componentName;
  }

  set componentName(value: string) {
    this._componentName = value;
  }

  get componentIsShared(): boolean {
    return this._componentIsShared;
  }

  set componentIsShared(value: boolean) {
    this._componentIsShared = value;
  }

  get componentOwnerId(): string {
    return this._componentOwnerId;
  }

  set componentOwnerId(value: string) {
    this._componentOwnerId = value;
  }

  get sonraiOnly(): boolean {
    return this._sonraiOnly;
  }

  set sonraiOnly(value: boolean) {
    this._sonraiOnly = value;
  }

  get componentActionId(): string {
    return this._componentActionId;
  }

  set componentActionId(value: string) {
    this._componentActionId = value;
  }

  get componentActionDescription(): string {
    return this._componentActionDescription;
  }

  set componentActionDescription(value: string) {
    this._componentActionDescription = value;
  }

  get componentActionKey(): string {
    return this._componentActionKey;
  }

  set componentActionKey(value: string) {
    this._componentActionKey = value;
  }

  toJson(): Object {
    const object = {
      user_id: this.userId,
      role_id: this.roleId,
      role_name: this.roleName,
      role_description: this.roleDescription,
      is_enabled: this.isEnabled,
      component_id: this.componentId,
      component_class: this.componentClass,
      component_path: this.componentPath,
      component_description: this.componentDescription,
      component_name: this.componentName,
      component_is_shared: this.componentIsShared,
      component_owner_id: this.componentOwnerId,
      sonrai_only: this.sonraiOnly,
      component_action_id: this.componentActionId,
      component_action_description: this.componentActionDescription,
      component_action_key: this.componentActionKey
    };
    Object.keys(object).forEach(k => !object[k] && typeof object[k] !== 'boolean' && object[k] !== undefined && delete object[k]);
    return object;
  }

  fromJson(input: any): MyPermissionsModel {
    return new MyPermissionsModel(input['user_id'], input['role_id'], input['role_name'],
      input['role_description'], input['is_enabled'], input['component_id'], input['component_class'],
      input['component_path'], input['component_description'], input['component_name'], input['component_is_shared'], input['component_owner_id'],
      input['sonrai_only'], input['component_action_id'], input['component_action_description'], input['component_action_key']);
  }
}
